<template>
  <div v-if="loading" class="mini-calendar-loading">
    <div class="mini-calendar-loading-content">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MiniCalendarLoading",
  computed: {
    ...mapGetters(["loading"]),
  },
};
</script>
